export default "__VITE_ASSET__IrGg6I3___"